/**
 * Created by mac on 2/3/20
 */

const Furniture = function (home, data, id) {
    cleverapps.EventEmitter.call(this);

    this.home = home;
    Object.assign(this, data);
    this.id = id;
    this.stage = 0;
};

Furniture.prototype = Object.create(cleverapps.EventEmitter.prototype);
Furniture.prototype.constructor = Furniture;

Furniture.prototype.bindUnit = function (unit) {
    this.unit = unit;
    this.stage = unit.stage;
};

Furniture.prototype.isCurrent = function () {
    return this.id === this.home.getCurrentFurnitureId();
};

Furniture.prototype.setFresh = function (fresh) {
    this.fresh = fresh;
};

Furniture.prototype.isFresh = function () {
    return this.fresh;
};

Furniture.prototype.amountStages = function () {
    return this.stages.length;
};

Furniture.prototype.isComplete = function () {
    if (!this.isCurrent()) {
        return false;
    }

    if (this.upgradeType === "throwaway" && !this.unit) {
        return true;
    }

    return this.stage >= this.amountStages();
};

Furniture.prototype.getInfo = function () {
    return this.stages[this.stage];
};

Furniture.prototype.getReadyPercent = function () {
    const availableStars = cleverapps.meta.getSelectedLocation().stars;
    const percent = Math.min(100, (availableStars / this.getInfo().cost) * 100);
    return Math.floor(percent);
};

Furniture.prototype.canBeUpgraded = function () {
    return this.isCurrent() && !this.isComplete() && this.getInfo().cost <= cleverapps.meta.getSelectedLocation().stars;
};

Furniture.prototype.getStage = function () {
    return this.unit && this.unit.stage;
};

Furniture.prototype.updateActiveState = function () {
    this.unit.findComponent(HomefixIdComponent).update();
};

Furniture.prototype.nextStage = function () {
    this.stage++;
    this.updateActiveState();
};
